import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormGroupComponent } from './form-validations/components/form-group/form-group.component';
import { FormControlDirective } from './form-validations/directives/form-control.directive';
import { FormValidationDirective } from './form-validations/directives/form-validation.directive';
import { MessagesComponent } from './form-validations/components/messages/messages.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AutoFocusFirstInputDirective } from './directives/auto-focus-first-input.directive';



@NgModule({
  declarations: [
    FormGroupComponent,
    MessagesComponent,
    FormControlDirective,
    FormValidationDirective,
    AutoFocusFirstInputDirective],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule
  ],
  exports: [
    FormGroupComponent,
    MessagesComponent,
    FormControlDirective,
    FormValidationDirective,
    AutoFocusFirstInputDirective,
    ReactiveFormsModule,
    FormsModule],
  providers: [],
})
export class FormLibModule { }
